export default {
  ApiHost: 'https://webappapiprod.azurewebsites.net',
  udi: {
    endpoint: 'https://www.accounts.philips.com/c2a48310-9715-3beb-895e-000000000000',
    clientId: '732a517d-4d7f-4280-b2be-5b391e43e6b6'
  },
  prismic: {
    endpoint: 'https://philips.cdn.prismic.io/api/v2',
    token: 'MC5XNDN4RlNZQUFDY0FPVGpI.77-977-9LO-_vUvvv71C77-9VSTvv73vv73vv71S77-977-9CO-_ve-_ve-_vXnvv73vv71_fe-_ve-_vTXvv70J77-9cA'
  }
}
